import type { RequestLeaveItem } from "views/RequestLeave/types"

import { DateTime } from "luxon"
import { getDefaultWorkCycleDateRange } from "utils/dateRange"

export const getDefaultRequestLeaveDateRange = getDefaultWorkCycleDateRange

export const formatRequestLeavePeriod = (startDate: string, endDate: string) => {
  const start = DateTime.fromISO(startDate)
  const end = DateTime.fromISO(endDate)

  if (!start.isValid || !end.isValid) return "—"
  if (start.hasSame(end, "day")) {
    return `${start.toFormat("HH:mm")} - ${end.toFormat("HH:mm, dd/MM/yyyy")}`
  }

  return `${start.toFormat("HH:mm dd/MM/yyyy")} - ${end.toFormat("HH:mm dd/MM/yyyy")}`
}

export const filterRequestLeaves = (
  leaves: RequestLeaveItem[],
  filters: {
    attendeeIds?: number[]
  },
) => {
  const attendeeIds = filters.attendeeIds?.length ? new Set(filters.attendeeIds) : null

  return leaves.filter((leave) => {
    if (attendeeIds && !attendeeIds.has(leave.attendee.id)) return false
    return true
  })
}

export const groupRequestLeavesByAttendee = (leaves: RequestLeaveItem[]) => {
  const groups = new Map<
    number,
    {
      attendee: RequestLeaveItem["attendee"]
      id: number
      leaves: RequestLeaveItem[]
    }
  >()

  leaves.forEach((leave) => {
    const attendeeId = leave.attendee.id
    const group = groups.get(attendeeId)

    if (group) {
      group.leaves.push(leave)
      return
    }

    groups.set(attendeeId, {
      attendee: leave.attendee,
      id: attendeeId,
      leaves: [leave],
    })
  })

  return Array.from(groups.values())
}
